var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import React from 'react';
import Drawer from "antd/es/drawer";
import "antd/es/drawer/style/index.js";
import { observer } from 'mobx-react';
import { MenubarPathMobile_ } from '../../Path/MenubarPathMobile_';
let MenubarMobilePathDrawer = class MenubarMobilePathDrawer extends React.Component {
    get menubarMobile() {
        return this.props.app.menubar.menubarMobile;
    }
    render() {
        const { app } = this.props;
        if (!app.menubarPath.menubarLocation)
            return null;
        if (!this.menubarMobile.isPathDrawerOpen)
            return null;
        return (React.createElement(Drawer, { title: "Lernthema wechseln", placement: "top", visible: this.menubarMobile.isPathDrawerOpen, style: { marginTop: 45 }, bodyStyle: { padding: 0 }, onClose: this.menubarMobile.closePathDrawer, destroyOnClose: true },
            React.createElement(MenubarPathMobile_, { app: app })));
    }
};
MenubarMobilePathDrawer = __decorate([
    observer
], MenubarMobilePathDrawer);
export { MenubarMobilePathDrawer };
